/**
 * Role Definitions for Backoffice App
 *
 * These roles define the authorization levels in the Kostbar Backoffice App.
 * Roles are assigned by the backend and included in the JWT token.
 */

export const ROLES = {
  /** System administrator with all permissions */
  SUPER_ADMIN: 'SUPER_ADMIN',

  /** Tenant-level administrator (can delete products, manage users) */
  TENANT_ADMIN: 'TENANT_ADMIN',

  /** Restaurant manager (can create pairing codes, publish bundles) */
  MANAGER: 'MANAGER',

  /** General staff member (basic product and price management) */
  ASSISTANT: 'ASSISTANT',
} as const

export type Role = (typeof ROLES)[keyof typeof ROLES]
